import { graphql, Link, useStaticQuery } from "gatsby";
import _ from "lodash";
import * as React from "react";

interface SimplifiedBlogPosts {
    [key: string]: {
        nodes: {
            slug: string;
            title: string;
        }[];
    };
}

export const BlogLinks = ({
    continent,
    excludeSlug
}: {
    continent: string;
    excludeSlug?: string;
}) => {
    const data: SimplifiedBlogPosts = useStaticQuery(graphql`
        {
            allContentfulPost(
                filter: { node_locale: { eq: "en-US" } }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            europe: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: { elemMatch: { slug: { eq: "europe" } } }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            asia: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: { elemMatch: { slug: { eq: "asia" } } }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            africa: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: { elemMatch: { slug: { eq: "africa" } } }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            australia: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: { elemMatch: { slug: { eq: "australia" } } }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            northAmerica: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: {
                        elemMatch: { slug: { eq: "north-america" } }
                    }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            centralAmerica: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: {
                        elemMatch: { slug: { eq: "central-america" } }
                    }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            southAmerica: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: {
                        elemMatch: { slug: { eq: "south-america" } }
                    }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
            middleEast: allContentfulPost(
                filter: {
                    node_locale: { eq: "en-US" }
                    blogCategory: { elemMatch: { slug: { eq: "middle-east" } } }
                }
                sort: { createdAt: DESC }
                limit: 10
            ) {
                nodes {
                    slug
                    title
                }
            }
        }
    `);
    const slugToKey = {
        "middle-east": "middleEast",
        "north-america": "northAmerica",
        "central-america": "centralAmerica",
        "south-america": "southAmerica"
    };
    const key = slugToKey[continent] || continent;
    let posts = [
        ...(key ? data[key]?.nodes : []),
        ...data.allContentfulPost.nodes
    ];
    if (excludeSlug) {
        posts = posts.filter((post) => post.slug !== excludeSlug);
    }
    posts = _.uniqBy(posts, (post) => post.slug);
    posts = posts.slice(0, 15);
    // TODO locale
    return (
        <>
            <h2 className="w-destination-header font-destination-header m-auto mt-16">
                {excludeSlug
                    ? "Other Sunheron blog posts"
                    : "Our latest blog posts"}
            </h2>
            <div className="h-4" />
            <ul>
                {posts.map((post) => (
                    <div
                        className="mx-auto my-1 px-4 text-center md:px-10 xl:px-12"
                        key={post.slug}
                    >
                        <Link
                            to={`/blog/${post.slug}`}
                            className="app-href text-sm"
                        >
                            {post.title}
                        </Link>
                    </div>
                ))}
            </ul>
        </>
    );
};
